export default __webpack_public_path__ + "media/images/onboarding-bg-7f18d46d.png";